interface Props {
    placeholderText: string;
}

export const Placeholder = ({ placeholderText }: Props) => {
    return <div className="editor-placeholder">{placeholderText}</div>;
};
